import { atom } from 'jotai';
export const $PageLoading = atom(false);
//# sourceMappingURL=page-loading.js.map